import { Link } from "react-router-dom";
import Image from "../../common-elements/media";
import { dynamicImage } from "../../service";
import { SVG } from "../../AbstractElements";
import { setToggleSidebar } from "../../redux-tool-kit/reducers/LayoutSlice";
import { useAppDispatch, useAppSelector } from "../../redux-tool-kit/Hooks";

const HeaderLogo = () => {
  const dispatch = useAppDispatch();
  const {toggleSidebar} = useAppSelector((state)=>state.layout)
  return (
    <div className="header-logo-wrapper col-auto p-0">
      <div className="logo-wrapper">
        <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
          <Image
            className="img-fluid for-light"
            src={dynamicImage("dashboard-8/linnk_logo.png")}
            alt="logo"
          />
          <Image
            className="img-fluid for-dark"
            src={dynamicImage("logo/logo.png")}
            alt="logo"
          />
        </Link>
      </div>
      <div className="toggle-sidebar"> 
        <SVG className="sidebar-toggle" iconId="stroke-animation" onClick={()=>dispatch(setToggleSidebar(!toggleSidebar))} /> 
      </div>
    </div>
  );
};

export default HeaderLogo;
